import { createSelector } from "@reduxjs/toolkit"
import { type Address, getAddress } from "viem"
import type { LiabilityValues } from "../actions/simulation"
import type { EnabledVaultsInfo } from "../types"

export const reduceLiabilityValues = createSelector(
  [(accountStatus: EnabledVaultsInfo[]) => accountStatus],
  (accountStatus) => {
    const data = new Map<Address, Map<Address, LiabilityValues>>()
    for (const status of accountStatus) {
      if (!status) continue
      const { evcAccountInfo, vaultAccountInfo } = status
      const account = evcAccountInfo.account
      const liabilities = new Map<Address, LiabilityValues>()
      for (const info of vaultAccountInfo) {
        const { vault, borrowed, isController, liquidityInfo } = info
        if (borrowed > 0n) {
          liabilities.set(getAddress(vault), {
            isController,
            liabilityValue: liquidityInfo.liabilityValueBorrowing,
            queryFailure: liquidityInfo.queryFailure,
          })
        }
      }
      if (liabilities.size > 0) {
        data.set(getAddress(account), liabilities)
      }
    }

    return data
  },
)
